import { DestroyRef, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

export type FormOptions<T> = {
  form: FormGroup;
} & T;

export abstract class FormTemplate<T = any> {
  protected fb = inject(FormBuilder);
  protected destroyRef = inject(DestroyRef);

  protected form: FormGroup;

  init({ form, ...options }: FormOptions<T>): void {
    this.form = form;
    this.onFormReady(options as T);
  }

  onFormReady(options?: T): void {}
}
